// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ZyZf","fileBtn":"File_fileBtn__3YUxr","closeBtn":"File_closeBtn__2pG-G","fileSelected":"File_fileSelected__3PSxz","disabled":"File_disabled__20EWD"};